import { Form } from 'react-bootstrap-5';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function ShareLinkEmailInput({
  disabled,
  email,
  isValidEmail,
  onChange,
}) {
  const [canShowInvalidEmail, setCanShowInvalidEmail] = useState(false);

  return (
    <React.Fragment>
      <Form.Label className="mb-1">
        Email Address <span className="text-danger fw-normal">(Required)</span>
      </Form.Label>
      <Form.Control
        autoFocus
        disabled={disabled}
        placeholder="Enter email address"
        type="email"
        value={email}
        onBlur={() => setCanShowInvalidEmail(true)}
        onChange={e => onChange('email', e.target.value)}
      />
      <div className={`mt-1 text-danger ${!isValidEmail && canShowInvalidEmail ? 'visible' : 'invisible'}`}>
        Invalid Email
      </div>
    </React.Fragment>
  );
}

ShareLinkEmailInput.propTypes = {
  disabled: PropTypes.bool,
  email: PropTypes.string.isRequired,
  isValidEmail: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
